import Operations from "./Operations";

const Incidents = () => <Operations resource="incidents" />;

export default Incidents;
